import { Select } from '@material-ui/core';
import PropTypes from 'prop-types';
import { memo } from 'react';
import useStyles from './style';

const TwNativeSelect = ({
  options,
  value,
  onChange,
  defaultOptionLabel,
  valueProperty,
  labelProperty,
  fullWidth,
}) => {
  const classes = useStyles();
  return (
    <Select
      property="test"
      style={{ fontSize: 'inherit' }}
      native
      fullWidth={fullWidth}
      value={value}
      variant="outlined"
      onChange={onChange}
      classes={classes}
      label
    >
      {defaultOptionLabel && <option value="">{defaultOptionLabel}</option>}
      {options.map((cruiseline) => (
        <option value={cruiseline[valueProperty]} key={cruiseline[valueProperty]}>
          {cruiseline[labelProperty]}
        </option>
      ))}
    </Select>
  );
};

TwNativeSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultOptionLabel: PropTypes.string,
  valueProperty: PropTypes.string,
  labelProperty: PropTypes.string,
  fullWidth: PropTypes.bool,
};

TwNativeSelect.defaultProps = {
  defaultOptionLabel: undefined,
  valueProperty: 'value',
  labelProperty: 'label',
  fullWidth: false,
};

export default memo(TwNativeSelect);
